module.exports = __webpack_public_path__ + "static/media/chevron-right.05af0df5.svg";